import moment from 'moment';
import AvatarWithName from '../common/avtar/AvatarWithName';
import AvatarGroup from '../common/avtar/AvatarGroup';
import {buildLocation, buildUserName} from '../../utils';

const HeaderDisplay = ({title, value}) => (
  <div className="flex flex-col justify-around">
    <div className="font-medium opacity-50">{title}</div>
    <div className="font-medium">{value}</div>
  </div>
);

const JobBoardHeader = ({jobDetails, count}) => {
  const {
    title = '',
    vacancies = 0,
    city = null,
    state = null,
    createdAt: jobCreatedAt,
    employer,
  } = jobDetails;

  const userName = buildUserName(employer?.firstName, employer?.lastName);

  return (
    <div className="flex justify-between bg-white py-8">
      <div className="flex gap-8">
        <div className="py-4 px-8 text-xl font-medium text-primary border-r-2">
          {title}
        </div>
        <div className="grid grid-cols-4 gap-4">
          <HeaderDisplay title="Vacancies" value={vacancies} />
          <HeaderDisplay title="Location" value={buildLocation(city, state)} />
          <HeaderDisplay
            title="Creation date"
            value={moment(jobCreatedAt).format('DD/MM/YYYY')}
          />
          <div className="flex flex-col justify-around">
            <div className="font-medium opacity-50">Primary recruiter</div>
            <div className="font-medium">
              <AvatarWithName name={userName} />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center px-8">
        <AvatarGroup count={count} />
      </div>
    </div>
  );
};

export default JobBoardHeader;
